"use client";

import { useEffect, useMemo, useState } from "react";
import { usePathname } from "@/i18n/navigation";

export function Carousel() {
	const [isSafari] = useState(false);
	useEffect(() => {
		// setIsSafari(!!value);
	});

	const pathname = usePathname();

	const scale = ["scale-150", "scale-110", "scale-150", "scale-150", "scale-150", "scale-150", "scale-150", "scale-150", "scale-150"];
	const padding = ["", "px-6", "", "", "", "", "", "", ""];

	const imgData: { alt: string; uri: string }[] = [
		{ alt: "University of Birmingham logo", uri: "/uni-logos/uob.png" },
		{ alt: "Bowling Green State University logo", uri: "/uni-logos/bgsu.png" },
		{ alt: "Loughborough University Logo", uri: "/uni-logos/lough.png" },
		{ alt: "University of Oulu logo", uri: "/uni-logos/oulu.png" },
		{ alt: "King Edward VI High School Logo", uri: "/case-studies/KEHS_logo.png" },
		{ alt: "Wolverhampton Grammar School Logo", uri: "/WGS_logo_crest.jpg" },
		{ alt: "St Mary's University Logo", uri: "/st_marys_logo.png" },
		{ alt: "EAB Logo", uri: "/EAB.png" },
		{ alt: "Educause Logo", uri: "/educause.png" }
	];

	const imgs = useMemo(() => {
		return (
			<div
				className={
					"h-18 flex flex-row items-center justify-center align-middle" +
					(isSafari ? "animate-none flex-wrap" : "w-max min-w-fit motion-safe:animate-[scroll_30s_linear_0s_infinite] flex-nowrap running")
				}
			>
				{imgData.map((img, i) => {
					return (
							<img
								alt={img.alt}
								key={i}
								src={img.uri}
								className={`mx-7 h-[63px] max-h-[200px] object-contain w-30 /w-40 p-3 ${scale[i]}${padding[i]}`}
								loading="lazy"
								decoding="async"
								fetchPriority="low"
							></img>
					);
				})}
			</div>
		);
	}, [isSafari]);

	return (
		<div
			className={`${pathname === "/" ? "w-full max-w-7xl overflow-hidden py-2.5" : "w-10/12 lg:w-9/12"} pt-[140px] lg:pt-80 relative mx-auto h-fit ${isSafari ? "overflow-visible" : "overflow-hidden"}`}
		>
			<div className="text-center text-sm font-semibold text-gray-500 mb-5 tracking-wide uppercase">Trusted by leading institutions worldwide</div>
			<div className={`flex w-fit flex-row ${isSafari ? "overflow-visible" : "overflow-hidden"}`}>
				{imgs}
				{!isSafari && imgs}
				{!isSafari && imgs}
			</div>
			<div className="absolute bottom-0 left-0 w-full h-[100px] bg-linear-to-r from-white to-transparent to-10%"></div>
			<div className="absolute bottom-0 right-0 w-full h-[100px] bg-linear-to-l from-white to-transparent to-10%"></div>
		</div>
	);
}
